import {
  LOAD_MASTERDATA_SUB_MATERIAL,
  CREATE_MASTERDATA_SUB_MATERIAL,
  LOAD_SUB_MATERIAL_DETAIL,
  UPDATE_MASTERDATA_SUB_MATERIAL,
  EXPORT_MASTERDATA_SUB_MATERIAL,
  IMPORT_SUB_MATERIAL,
  REMOVE_LISTS,
} from './actions'

const initialState = {
  Lists: [],
  listsEdit: '',
  total: 1,
  loading: false,
  draw: -1,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_LISTS:
      return initialState

    case LOAD_MASTERDATA_SUB_MATERIAL.REQUEST:
      const { loading } = action.payload.data
      return {
        ...state,
        loading: loading,
      }

    case LOAD_MASTERDATA_SUB_MATERIAL.SUCCESS:
      const { page } = action.payload
      for (let i = 0; i < action.payload.lists.data.length; i++) {
        action.payload.lists.data[i].rowNumber = i + 1
        if (page > 1)
          action.payload.lists.data[i].rowNumber =
            action.payload.lists.data[i].rowNumber + (page - 1) * 10
      }
      return {
        ...state,
        Lists: action.payload.lists.data,
        total:
          action.payload.lists.total - 1 <= 0
            ? 1
            : action.payload.lists.total <= 0
            ? 1
            : action.payload.lists.total,
        loading: false,
        draw: Math.floor(Math.random() * 999 + 1),
      }

    case CREATE_MASTERDATA_SUB_MATERIAL.REQUEST:
      return {
        ...state,
        loading: true,
      }

    case CREATE_MASTERDATA_SUB_MATERIAL.SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case LOAD_SUB_MATERIAL_DETAIL.REQUEST:
      return {
        ...state,
        loading: true,
      }

    case LOAD_SUB_MATERIAL_DETAIL.SUCCESS:
      return {
        ...state,
        listsEdit: action.payload.listsEdit.data,
        loading: false,
      }

    case UPDATE_MASTERDATA_SUB_MATERIAL.REQUEST:
      return {
        ...state,
        loading: true,
      }

    case UPDATE_MASTERDATA_SUB_MATERIAL.SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case EXPORT_MASTERDATA_SUB_MATERIAL.REQUEST:
      return {
        ...state,
        loading: true,
      }

    case EXPORT_MASTERDATA_SUB_MATERIAL.SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case IMPORT_SUB_MATERIAL.REQUEST:
      return {
        ...state,
        loading: true,
      }

    case IMPORT_SUB_MATERIAL.SUCCESS:
      return {
        ...state,
        loading: false,
      }

    default:
      return state
  }
}
